import styled from "styled-components";

export const MusicHallRegisContactInfoFormStyled = styled.div`
  /* หน้าตรวจสอบข้อมูล (disabled) พื้นเทาเหมือน dropdown/textarea ให้รู้ว่าแก้ไม่ได้
     แก้เฉพาะฟอร์มขั้นตอนจองห้อง ไม่แตะ TextField กลางที่ใช้อีกหลายหน้า */
  input:disabled {
    background: ${({ theme }) => theme.COLORS.GRAY_6};
  }
  .checkbox_wrap {
    margin-bottom: 15px;
  }
  .input_wrap {
    margin-bottom: 15px;
    &.mb_30 {
      margin-bottom: 30px;
    }
  }
`;
